export const sortedCoursesSelector = (user, golfCoursesList) => {
    if (user && user?.roleId === 2) {
        return golfCoursesList
            .filter(it => it.data.adminId === user?.userName && !!it.data.isOpen)
            .sort(function (a, b) {
                return a.courseName.localeCompare(b.courseName, 'fi');
                // if (a.courseName.trim() < b.courseName.trim()) {
                //     return -1;
                // }
                // if (a.courseName.trim() > b.courseName.trim()) {
                //     return 1;
                // }
                // return 0;
            });
    } else {
        return golfCoursesList.filter(i => !!i.data.isOpen).sort(function (a, b) {
            // let courseName = a.data.courseName.replace('Ä', "A");
            // let courseName1 = b.data.courseName.replace('Ä', "A");
            return a.data.courseName.localeCompare(b.data.courseName, 'fi');
            // if (courseName?.trim() < courseName1?.trim()) {
            //     return -1;
            // }
            // if (courseName?.trim() > courseName1?.trim()) {
            //     return 1;
            // }
            // return 0;
        });
    }
}
